var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.betDetailURL !== null,
          expression: "betDetailURL !== null",
        },
      ],
      staticClass: "iframe-block betDetail",
    },
    [
      _c("iframe", {
        attrs: { scrolling: "no", frameborder: "0", src: _vm.betDetailURL },
      }),
      _vm.showCloseBtn
        ? _c("div", {
            staticClass: "close-iframe-btn",
            on: { click: _vm.closeBetDetailIframe },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }